export default __webpack_public_path__ + "static/media/facebook.c72bcdf3.svg";